import { render } from "./PopoverButton.vue?vue&type=template&id=eafc9ecc"
import script from "./PopoverButton.vue?vue&type=script&lang=js"
export * from "./PopoverButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__